export default __webpack_public_path__ + "static/media/Logo-ISO.4c6bd7ab.png";